module.exports = __webpack_public_path__ + "static/media/filter.44bed733.svg";